const formSelectOptions = [
  { value: true, label: "Da" },
  { value: false, label: "Ne" },
];

export default formSelectOptions;
